import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

export interface BreadcrumbItem {
  /** Chave i18n (Transloco). Ignorada se `label` estiver definido. */
  labelKey?: string;
  /** Texto livre — útil para nomes vindos da API (indicador, etc.). */
  label?: string;
  path?: string;
}

@Component({
  selector: 'app-page-shell',
  standalone: true,
  imports: [RouterLink, TranslocoPipe, LocalizedRouterLinkPipe],
  templateUrl: './page-shell.component.html',
})
export class PageShellComponent {
  readonly breadcrumb = input([], {
    transform: (value: BreadcrumbItem[] | null | undefined): BreadcrumbItem[] => value ?? [],
  });
  readonly width = input<'narrow' | 'wide'>('narrow');
}
